import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';
import Decimal from 'decimal.js';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const [data1, setData1] = useState([]);
  const token = authServices.getToken();

  const SubSubCommodity = async () => {
    try {
      const response = await apiClient.get(`/api/admin/sub_sub_commodity/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData1(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData1 = Array.from(
    new Map(data1.map((item) => [item.subSubCommodity, item])).values()
  );

  const validData1 = filteredData1.filter((item) => item.subSubCommodity);

  // *******************************************************************************************************************************
  const [data2, setData2] = useState([]);

  const fetchPortType = async () => {
    try {
      const response = await apiClient.get(`/api/admin/port_type/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.portType, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.portType);

  const [data3, setData3] = useState([]);

  const fetchUnit = async () => {
    try {
      const response = await apiClient.get(`/api/admin/unit/getAll`,
        {
          params: {
            pageNumber: 0,
            pageSize: 200
          },
          headers: {
            'access_token': token,
          }
        }
      );
      setData3(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData3 = Array.from(
    new Map(data3.map((item) => [item.name, item])).values()
  );

  const validData3 = filteredData3.filter((item) => item.name);


  const [formData, setFormData] = useState({
    subSubCommodityId: null,
    unitId: null,
    portTypeId: null,
    charges: null,
  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };


  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.subSubCommodityId === null) {
      formErrors.subSubCommodity = 'subSubCommodity cannot be empty';
    }
    if (formData.unit === null) {
      formErrors.unit = 'unit cannot be empty';
    }
    if (formData.portTypeId === null) {
      formErrors.portType = 'portType cannot be empty';
    }
    if (formData.charges === null) {
      formErrors.charges = 'charges cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };


  const AllData = {
    subSubCommodityId: {
      id: formData.subSubCommodityId
    },
    unitId: {
      id: formData.unitId
    },
    portTypeId: {
      id: formData.portTypeId
    },
    charges: new Decimal(formData.charges ? formData.charges : 0.00).toFixed(2) || 0.00,
  }

  console.log(AllData)
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/charges/add', AllData, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {

        setFormData({
          subSubCommodityId: null,
          unitId: null,
          portTypeId: null,
          charges: null,
        });

      }
      else {
        console.log(response.data.message)
      }

      // Refresh the data list after successful submission
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle();
      // window.location.reload();
    }
  };

  useEffect(() => {
    fetchUnit()
    fetchPortType()
    SubSubCommodity()
  }, [])

  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Charges</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom2" >
                  <form >

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">
                        {/* <label htmlFor="subSubCommodityId" className="label-custom">Sub Sub CommodityId</label>
                        <input
                          type="number"
                          className={`input-custom ${errors.subSubCommodityId ? 'input-error' : ''}`}
                          id="subSubCommodityId"
                          name="subSubCommodityId"
                          value={formData.subSubCommodityId.id}
                          onChange={handleChange}
                        /> */}

                        <label htmlFor="subSubCommodityId" className="label-custom">Sub Sub Commodity</label>
                        <Autocomplete
                          className={` ${errors.subSubCommodityId ? 'input-error' : ''}`}
                          disablePortal
                          options={validData1} // Full user object
                          getOptionLabel={(option) => option.subSubCommodity} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, subSubCommodityId: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, subSubCommodityId: "" }); // Reset state 
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.subSubCommodity}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '120px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block">
                        {/* <label htmlFor="unitId" className="label-custom">Unit Id</label>
                        <input
                          type="number"
                          className={`input-custom ${errors.unitId ? 'input-error' : ''}`}
                          id="unitId"
                          name="unitId"
                          value={formData.unitId}
                          onChange={handleChange2}
                        // placeholder="Enter Billing Name"
                        /> */}

                        <label htmlFor="unitId" className="label-custom">Unit</label>
                        <Autocomplete
                          className={` ${errors.unitId ? 'input-error' : ''}`}
                          disablePortal
                          options={validData3} // Full user object
                          getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, unitId: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, unitId: "" }); // Reset state 
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.name}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '120px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />

                      </div>
                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">
                        {/* <label htmlFor="portType" className="label-custom">Port TypeId</label>
                        <input
                          type="number"
                          className={`input-custom ${errors.portTypeId ? 'input-error' : ''}`}
                          id="portTypeId"
                          name="portTypeId"
                          value={formData.portTypeId}
                          onChange={handleChange2}
                        // placeholder="Enter Amount"
                        /> */}

                        <label htmlFor="portType" className="label-custom">portType</label>
                        <Autocomplete
                          className={` ${errors.portType ? 'input-error' : ''}`}
                          disablePortal
                          options={validData2} // Full user object
                          getOptionLabel={(option) => option.portType} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, portTypeId: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, portTypeId: "" }); // Reset state 
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.portType}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '110px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />

                      </div>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="charges" className="label-custom">Charges</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.charges ? 'input-error' : ''}`}
                          id="charges"
                          name="charges"
                          value={formData.charges}
                          onChange={handleChange2}
                          onInput={(e) => {
                            // Allow digits and a single decimal point
                            e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                            // Prevent more than one decimal point
                            if ((e.target.value.match(/\./g) || []).length > 1) {
                              e.target.value = e.target.value.replace(/\.+$/, '');
                            }
                          }}
                        />
                      </div>
                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
